import {useEffect, useRef} from "react";
import {useSearchParams} from "react-router-dom";
import {useTheCellMapContext} from "../../contexts/TheCellMapContext";
import {URLParam} from "../../types/enums";
import {parseNumericParam} from "../../utils/urlParams";

const ListCurrentGeneController = () => {
  const {selectedGenes, currentGene, setCurrentGene} = useTheCellMapContext();
  const [searchParams] = useSearchParams();

  const initialFocusRef = useRef<number | undefined>(undefined);
  const didReadInitialFocusRef = useRef(false);

  if (!didReadInitialFocusRef.current) {
    initialFocusRef.current = parseNumericParam(searchParams.get(URLParam.LIST_FOCUS));
    didReadInitialFocusRef.current = true;
  }

  /** Initialize current gene */
  useEffect(() => {
    if (selectedGenes.length === 0) {
      // No genes selected, current gene should be undefined
      if (currentGene) setCurrentGene(undefined);
      return;
    }

    const initialFocus = initialFocusRef.current;
    if (initialFocus) {
      // Consume URL focus exactly once when selected genes become available.
      initialFocusRef.current = undefined;
      const focusedGene = selectedGenes.find(gene => gene.value === initialFocus);
      if (focusedGene) {
        if (currentGene?.value !== focusedGene.value) {
          setCurrentGene(focusedGene);
        }
        return;
      }
    }

    const hasCurrentGene = !!currentGene && selectedGenes.some(g => g.value === currentGene.value);
    if (hasCurrentGene) return;

    // No current gene yet or it's not in selected genes, set to most recently selected gene.
    setCurrentGene(selectedGenes[selectedGenes.length - 1]);
  }, [selectedGenes, currentGene, setCurrentGene]);

  return null;
}

export default ListCurrentGeneController;
